import View from "../common/views/ProductMasterView";
import components from "./components.js";
components.define("js-ProductView", View);